const cadastro_do_reordenamento_real = {
  path: "/cadastro-do-reordenamento-real",
  redirect: "/cadastro-do-reordenamento-real",
  meta: {
    breadCrumb: "Processo de Matrículas - Registrar Reordenamento",
  },
  children: [
    {
      path: "/cadastro-do-reordenamento-real",
      name: "cadastro-do-reordenamento-real",
      component: () =>
        import(
          "@/views/CadastroDoReordenamentoReal/CadastroDoReordenamentoRealHome.vue"
        ),
    },
    {
      path: "/cadastro-do-reordenamento-real/novo",
      name: "cadastro-do-reordenamento-real-novo",
      component: () =>
        import(
          "@/views/CadastroDoReordenamentoReal/CadastroDoReordenamentoRealCadastro.vue"
        ),
    },
    {
      path: "/cadastro-do-reordenamento-real/edit/:id",
      name: "cadastro-do-reordenamento-real-edit",
      component: () =>
        import(
          "@/views/CadastroDoReordenamentoReal/CadastroDoReordenamentoRealEdit.vue"
        ),
    },
  ],
};

export { cadastro_do_reordenamento_real };
